module.exports = __webpack_public_path__ + "img/ch.efb7dd83.svg";